{
  "actions": {
    "back": "Terug",
    "close": "Sluiten",
    "minimize": "Minimaliseren",
    "maximize": "Maximaliseren",
    "restore": "Herstellen"
  },
  "home": {
    "title": "Home",
    "role": "Product Designer & Developer",
    "pitch": "Ik hou me bezig met iets waar veel mensen op afhaken: complexiteit. Waar UX, techniek en business door elkaar lopen, zoek ik naar patronen, haal ik ruis weg en maak ik het weer logisch.",
    "available": "Beschikbaar voor opdrachten en vaste posities",
    "cta_work": "Bekijk mijn werk",
    "cta_contact": "Neem contact op"
  },
  "work": {
    "title": "Work",
    "heading": "Geselecteerd Werk",
    "filters": {
      "all": "Alles",
      "apps": "Applicaties",
      "video": "AI Video",
      "design": "Design"
    },
    "back": "Terug",
    "role": "Rol",
    "tech": "Technologie",
    "results": "Resultaten",
    "view_case": "Bekijk case study",
    "cta_title": "Klaar om jouw project te starten?",
    "cta_button": "Laten we praten"
  },
  "about": {
    "title": "Over Mij",
    "heading": "Het hele plaatje",
    "intro": "Eigenlijk ben ik een soort vertaler. Van vage ideeën en losse systemen naar iets wat werkt, schaalbaar is en gewoon fijn voelt voor de gebruiker. Ik ben op m'n best als iets 'te complex' lijkt.",
    "approach_title": "Hoe ik werk",
    "approach": "Mijn manier van werken draait om één ding: terug naar de essentie. Ik combineer dingen die normaal los van elkaar staan, maak abstracte ideeën snel concreet met prototypes en denk altijd vooruit. Alles wat niet nodig is, gaat eruit.",
    "capabilities_title": "Mijn pad & focus",
    "capabilities": {
      "ux": "UX als basis (sinds 2018) — Begonnen bij de gebruiker. Hoe denken mensen? Waar haken ze af? Wat voelt logisch en wat niet?",
      "tech": "Technisch inzicht — Frontend development om precies te snappen hoe dingen gebouwd worden, zodat design en techniek echt op elkaar aansluiten.",
      "ai": "AI als versneller — Niet als gimmick, maar om workflows slimmer te maken. Prompt engineering, AI-integraties en tools combineren.",
      "now": "Breed inzetbaar — Van websites en apps tot wireframes, mockups, flyers en dashboards. Ik doe gedegen UX-onderzoek, zoek alles uit en lever producten op die écht bij de klant aansluiten.",
      "drive": "Wat mij drijft — Ik test veel, bouw veel, en probeer dingen die niet helemaal binnen de lijntjes vallen. En ja, koffie helpt ook."
    }
  },
  "resume": {
    "title": "CV",
    "download": "Download CV (.pdf)",
    "experience": "Werkervaring",
    "education": "Opleiding",
    "skills": "Vaardigheden",
    "freelance_role": "Freelance Product Designer & Developer",
    "freelance_company": "MvlCreative",
    "freelance_period": "2021 — Heden",
    "freelance_description": "Ontwerp en bouw van schaalbare digitale producten. Van UX-strategie en design systems tot frontend development en AI-integraties. Ik overbruig de kloof tussen design, techniek en business.",
    "webheld_role": "Web Developer",
    "webheld_company": "Webheld — Baarn",
    "webheld_period": "2020 — 2021",
    "webheld_description": "Websites en webshops gebouwd en geoptimaliseerd in WordPress en Magento. Van custom development en SEO tot wireframing en visueel ontwerp.",
    "aim_role": "Web Developer",
    "aim_company": "Aim — Badhoevedorp",
    "aim_period": "2020",
    "aim_description": "Websites opgebouwd van ontwerp tot oplevering. WordPress-omgevingen onderhouden en doorontwikkeld.",
    "tweak_role": "Service Desk",
    "tweak_company": "Tweak — Almere",
    "tweak_period": "2019 — 2020",
    "tweak_description": "Eerste aanspreekpunt voor technische klantvragen. Probleemanalyse, troubleshooting en administratieve afhandeling.",
    "more_coming": "Meer werkervaring wordt binnenkort toegevoegd."
  },
  "contact": {
    "title": "Contact",
    "heading": "Neem contact op",
    "phone_label": "Telefoon",
    "location": "Almere, Nederland",
    "location_label": "Locatie",
    "availability": "Beschikbaar in heel Nederland en remote",
    "status": "Beschikbaar voor opdrachten en vaste posities",
    "cta_call": "Plan een videocall",
    "social_label": "Social",
    "status_label": "Status"
  },
  "boot": {
    "loading": "Creativiteit laden...",
    "design_systems": "Design systems initialiseren...",
    "connecting_ai": "AI verbinden...",
    "ready": "Gereed."
  },
  "command": {
    "placeholder": "Zoek of navigeer...",
    "projects": "Projecten",
    "navigation": "Navigatie",
    "settings": "Instellingen"
  }
}